/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { WhiteCard } from "../../../components/StyledComponents";
import CommonSection from '../../../components/CommonSection'; 
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import * as config from '../../../styles/config.module.scss';
import styled from '@emotion/styled';


const MarkdownSection = ({children,title}) => {
  return(
    <CommonSection css={css`
      > div{
        padding-top:0;
        padding-bottom:0;
      }
    `}>
      <Title>{title}</Title>
      <div css={css`
        position:relative;padding-bottom:48px;width: 100%;
        @media only screen and (max-width: ${breakpoint.smMax}){
          padding-bottom:16px;
        }

        @media only screen and (max-width: ${breakpoint.xsMax}){
          padding-bottom: 32px;
        }
      `}>
        <WhiteCard narrow={"true"} css={css`
          margin:0 auto;
          width:928px;
          text-align:left;
          font-size:${config.fontSizeNormal};
          line-height: 175%;
          padding-bottom: 32px;
          color:#444448;


          p{
            margin-bottom:16px;
            
          }
          h3{
            margin:32px 0 16px;
            font-size:${config.fontSizeH3};
            line-height:140%;
            color:#2C2C2C;
            

            @media only screen and (max-width: ${breakpoint.smMax}){
              font-size:${config.fontSizeSMH3};
            }
          
            @media only screen and (max-width: ${breakpoint.xsMax}){
              font-size:${config.fontSizeXSH3};
            }
          }

          code{
            font-family:inherit;
          }

          a{
            color:#C62828;
          }

          ul{
            
            list-style-type:none;
            margin-left:24px;
            margin-bottom:16px;
            > li{
              color:#444448;
              margin-bottom:6px;
              position:relative;
              white-space:break-all;
              &:before{
                top:.875em;
                margin-top:-2px;
                content:' ';
                display:block;
                position:absolute;
                left:-14px;
                width:4px;
                height:4px;
                border-radius:2px;
                background:#444448;
              }
            }

            ul:last-of-type,p:last-of-type{
              margin-bottom:0;
            }

            
          }

          ol{
            margin-left:24px;
            margin-bottom:16px;

            ul:last-of-type,p:last-of-type{
              margin-bottom:0;
            }
          }

          li, p{
            word-break:break-all;
            @media only screen and (max-width: ${breakpoint.xsMax}){
              font-size:14px;
              line-height:24px;
            }
          }

          @media only screen and (max-width: ${breakpoint.smMax}){
            padding-bottom: 16px;
          }

          
        `}>
          {children}
        </WhiteCard>
      </div>
    </CommonSection>
  );
};

export default MarkdownSection;

const Title = styled.h1`
  font-size:${config.fontSizeH1};
  padding-bottom:48px;
  margin:0 auto;
  width:100%;
  max-width:928px;
  color: #2C2C2E;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size:${config.fontSizeSMH1};
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size:${config.fontSizeXSH1};
  }

`;
